module.exports = __webpack_public_path__ + "static/media/wheel-needle.c9d6f147.png";